import React from 'react'
import style from './css/Footer.module.css'

function Footer() {
  return (
    <>
        <footer className="bg-dark text-light">
        <p className={`${style.p}text-center`}>Copyright &copy; 2024 SKY COMPUTER EDUCATION</p>
        <p className={`${style.p}text-center`}>All Rights Reserved ! </p>
        <p className={`${style.p}text-center`}> <i> ~~ Design & Developed by <a href="https://kunalkumar45.github.io/myportfolio/" target='blank'>Kunal Kumar</a> ~~</i></p>
    </footer>
    </>
  )
}

export default Footer
